<script>
export default {
  name: "BookingView",
  created() {
    this.$router.push("/booking/flight");
  }
};
</script>

<style scoped></style>
